import React, { useEffect } from "react";
import {
  BottomNavigationAction,
  Container,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import ModelViewer from "../../components/model-viewer/ModelViewer";
import FavoriteIcon from "@material-ui/icons/Favorite";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { StyledBottomNavigation } from "../../components/styled-bottom-nav/StyledBottomNavigation";
import Annotations from "../../components/annotations/Annotations";
import Customizer from "../../components/customizer/Customizer";
import Export from "../../components/export/Export";
import Environment from "../../components/environment/Environment";
import ModelSelect from "../../components/model-select/ModelSelect";
import CloseIcon from "@material-ui/icons/Close";
import StyleIcon from "@material-ui/icons/Style";
import PublicIcon from "@material-ui/icons/Public";
import TripOriginIcon from "@material-ui/icons/TripOrigin";
import "./Visualizer.css";
import HeaderLogo from "../../components/header-logo/HeaderLogo";

const useStyles = makeStyles(() => ({
  main: {
    height: "100%",
    padding: 0,
  },
  controllerContainer: {
    padding: "2rem",
  },
  controlBox: {
    position: "fixed",
    padding: "1rem",
    zIndex: "100",
    color: "#fff",
    minWidth: "330px",
    bottom: "4rem",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    pointerEvents: "none",
  },
  controlBoxInner: {
    background: "rgba(0,0,0,0.8)",
    WebkitBackdropFilter: "saturate(180%) blur(20px)",
    backdropFilter: "saturate(180%) blur(20px)",
    padding: "1rem",
    pointerEvents: "all",
    borderRadius: "1rem",
    maxHeight: "80vh",
  },
  controlBoxScroll: {
    maxHeight: "80vh",
    overflow: "scroll",
  },
  mutedText: {
    color: "#ff5c0094",
    paddingLeft: ".5rem",
  },
  bottomNavLabels: {
    color: "#acacac",
  },
  closeBtnBox: {
    position: "absolute",
    right: "1rem",
  },
  closeBtn: {
    color: "#fff",
  },
}));

const Visualizer = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState("");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [control, setControl] = React.useState("");

  useEffect(() => {
    switch (value) {
      case "Model":
        setControl(<ModelSelect />);
        break;
      case "Environment":
        setControl(<Environment />);
        break;
      case "Annotations":
        setControl(<Annotations />);
        break;
      case "Customize":
        setControl(<Customizer />);
        break;
      case "Export":
        setControl(<Export />);
        break;
      default:
        setControl("");
        break;
    }
  }, [value]);

  const handleClose = () => {
    setControl("");
    setValue("");
  };

  return (
    <>
      <HeaderLogo />
      <div className={classes.controlBox}>
        {control !== "" && (
          <div className={classes.controlBoxInner}>
            <div className={classes.closeBtnBox}>
              <IconButton
                aria-label="delete"
                className={classes.closeBtn}
                size="small"
                onClick={handleClose}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            </div>
            <div className={classes.controlBoxScroll}>{control}</div>
          </div>
        )}
      </div>
      <Container maxWidth={"xl"} className={classes.main}>
        <ModelViewer />
        <StyledBottomNavigation
          value={value}
          onChange={handleChange}
          showLabels
          className={classes.root}
        >
          <BottomNavigationAction
            className={classes.bottomNavLabels}
            label="Model"
            value="Model"
            icon={<TripOriginIcon />}
          />
          <BottomNavigationAction
            className={classes.bottomNavLabels}
            label="Environment"
            value="Environment"
            icon={<FavoriteIcon />}
          />
          <BottomNavigationAction
            className={classes.bottomNavLabels}
            label="Annotations"
            value="Annotations"
            icon={<LocationOnIcon />}
          />
          <BottomNavigationAction
            className={classes.bottomNavLabels}
            label="Customize"
            value="Customize"
            icon={<StyleIcon />}
          />
          <BottomNavigationAction
            className={classes.bottomNavLabels}
            label="Export"
            value="Export"
            icon={<PublicIcon />}
          />
        </StyledBottomNavigation>
      </Container>
    </>
  );
};

export default Visualizer;
